<template>

	<section id="Inspection">

		<div id="DidYouKnow">

			<div class="dyk-toggle" :class="{show: showDidYouKnowToggle}">

				<img :src="getDYK()" alt="Did you know?" v-on:click="showDidYouKnow = !showDidYouKnow" />

			</div>

			<div class="dyk-popup" :class="{show: showDidYouKnow}">

				<div class="dyk-popup__title">

					{{ $t('inspectionOfDefects') }}

				</div>

				<div class="dyk-popup__text">

					{{ $t('defectsOnTheInside') }}

				</div>

				<div class="dyk-popup__link">

					<router-link id="XRaySystems" to="/x-ray_series/systems">

						{{ $t('DiscoverOurXraySystems') }}

					</router-link>

				</div>

			</div>

		</div>

		<div id="Model"></div>

		<Popup
			:width="activePopup.width"
			:height="activePopup.height"
			:type="activePopup.type"
			:title="activePopup.title"
			:text="activePopup.text"
			:left="activePopup.left"
			:top="activePopup.top"
			:image="activePopup.image"
			:video="activePopup.video"
			:direction="activePopup.direction"
			bgcolor="#293279"
		></Popup>

		<div id="VideoPopup" v-if="showVideoPopup" style="background-color: #293279;">

			<video controls autoplay>

				<source :src="activePopup.video" />

			</video>

			<img class="close" @click="showVideoPopup = false" src="/image/close-w.png" alt="Close" />

		</div>

		<div id="ImagePopup" v-if="showImagePopup">

			<img class="popup-image" :src="imgPopup()" alt="Popup" />

			<img class="close" src="/image/close.png" alt="Close" @click="showImagePopup = false" />

		</div>

	</section>

</template>

<script>

	import Model from "../../model";
	import Popup from "../Popup";
	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				activePopup: {
					id: null,
					width: 0,
					height: 0,
					type: null,
					title: null,
					text: null,
					image: '',
					video: '',
					left: 0,
					top: 0,
					direction: ''
				},
				showImagePopup: false,
				showVideoPopup: false,
				imagePopup: '0',
				showDidYouKnowToggle: false,
				showDidYouKnow: false,
				popups: [
					{
						id: 'A',
						width: 865,
						height: 615,
						type: 'vertical',
						title: this.$t('cracks'),
						text: this.$t('underStressCracks'),
						image: '/image/inspection/cracks.jpg',
						video: ''
					},
					{
						id: 'B',
						width: 1110,
						height: 570,
						type: 'horizontal',
						title: this.$t('poresCavities'),
						text: this.$t('poresCavitiesLeadToLoss'),
						image: '/image/inspection/poren.png',
						video: '/image/inspection/poren.mp4'
					},
					{
						id: 'C',
						width: 787,
						height: 795,
						type: 'horizontal',
						title: this.$t('residuals'),
						text: this.$t('residualsSuchAsSand'),
						image: '/image/inspection/residuals.jpg',
						video: ''
					},
					{
						id: 'D',
						width: 592,
						height: 560,
						type: 'vertical',
						title: this.$t('anInvestmentThatPaysOff'),
						text: this.$t('aThoroughInspection'),
						image: '',
						video: ''
					},
					{
						id: 'E',
						width: 530,
						height: 224,
						type: 'vertical',
						title: this.$t('inclusions'),
						text: this.$t('inclusionsOfSlag'),
						image: '',
						video: ''
					}
				]
			};
		},
		mounted () {
			Model.startInspection(this.onClick);
			setTimeout(() => this.showDidYouKnowToggle = true, 500);
		},
		methods: {
			imgPopup() {
				return '/image/xrayseries/systems/'+this.imagePopup+'.'+i18n.locale+'.png';
			},
			onClick (hotspot) {

				if (event.target.id === 'XRaySystems') {

					//this.$router.push('/x-ray_systems');
					return;
				}

				if (event.target.id === '2DLink') {

					this.imagePopup = '3';
					this.showImagePopup = true;

					return;
				}

				if (event.target.id === '3DLink') {

					this.imagePopup = '2';
					this.showImagePopup = true;

					return;
				}

				this.showDidYouKnow = false;
				let tm = this.activePopup.direction === '' ? 0 : 500;

				if (event.target.id === 'showVideoPopup') {
					return;
				}

				this.activePopup = {
					id: null,
					width: this.activePopup.width,
					height: this.activePopup.height,
					type: null,
					title: null,
					text: null,
					image: '',
					video: '',
					left: this.activePopup.left,
					top: this.activePopup.top,
					direction: ''
				};

				if (hotspot === null) {
					return;
				}

				setTimeout(() => {
					for (let popup of this.popups) {
						if (popup.id === hotspot.name) {
							this.activePopup = popup;
							let direction = '';

							if (hotspot.position.y >= 540) {
								direction = 'top';
							} else {
								direction = 'bottom';
							}

							if (hotspot.position.x >= 960) {
								direction += 'left';
							} else {
								direction += 'right';
							}

							this.activePopup.left = hotspot.position.x;
							this.activePopup.top = hotspot.position.y;
							this.activePopup.direction = direction;
						}
					}
				}, tm);
			},
			startPopupVideo () {
				if (this.activePopup.video !== '') {
					this.showVideoPopup = true;
				}
			},
			getDYK () {

				return `/image/dyk-blue.${ i18n.locale }.png`;

			}
		},
		components: {
			Popup
		}
	};

</script>
